import { render, staticRenderFns } from "./staffLeaveHis.vue?vue&type=template&id=f0c52d90&scoped=true"
import script from "./staffLeaveHis.vue?vue&type=script&lang=js"
export * from "./staffLeaveHis.vue?vue&type=script&lang=js"
import style0 from "./staffLeaveHis.vue?vue&type=style&index=0&id=f0c52d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c52d90",
  null
  
)

export default component.exports